import { Tabs, Text } from "@mantine/core";
import { IconLogin, IconUserPlus } from "@tabler/icons";
import { useTranslation } from "next-i18next";
import { RegistrationForm } from "../../../login/RegistrationForm";
import { LoginForm } from "../../../login/LoginForm";
import { useColors } from "../../../../../hooks/colors/useColors";
import { isPhone } from "../../../../../constants/env";

export function AnonymousSignInSignUp() {
  const { i18n } = useTranslation("common");
  const { colors } = useColors();
  return (
    <div className="flex justify-center">
      <div className={!isPhone ? "max-w-xl min-w-[32rem]" : ""}>
        <Tabs
          defaultValue="signin"
          variant="pills"
          style={{
            tabsList: {
              display: "flex",
              justifyContent: "center",
              gap: 16,
            },
            tab: {
              borderRadius: 8,
              "&:hover": {
                opacity: 0.95,
              },
              "&[data-active]": {
                background: colors.primary,
              },
            },
          }}
        >
          <Tabs.List>
            <Tabs.Tab value="signin" leftSection={<IconLogin />}>
              <Text size="md" className="font-bold">
                {i18n.t("login.login")}
              </Text>
            </Tabs.Tab>
            <Tabs.Tab value="signup" leftSection={<IconUserPlus />}>
              <Text size="md" className="font-bold">
                {i18n.t("login.register")}
              </Text>
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="signin" pt="xs">
            <LoginForm />
          </Tabs.Panel>
          <Tabs.Panel value="signup" pt="xs">
            <RegistrationForm autoSignIn />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
}
